import React from 'react';
import { servicesData } from './ServicesData';
import { ChevronRight } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

// COLORS declared at the top as requested
const COLORS = {
  bgPrimary: "#0A0A0A",   // Deep Black
  bgSecondary: "#121212", // Slightly Lighter Black
  gold: "#A47148",        // Premium Brown (replacing gold)
  textLight: "#EAEAEA",
};

const ServicesList = () => {
  return (
    <>
        <Helmet>
  <title>Practice Areas | SKS Law Groups & Associates</title>

  <meta
    name="description"
    content="Explore the practice areas of SKS Law Groups & Associates. Our experienced legal team provides expert representation in civil, criminal, corporate, family, property, and commercial law matters."
  />

  <meta
    name="keywords"
    content="law firm Delhi, civil lawyer, criminal lawyer, corporate lawyer, family lawyer, property lawyer, legal services Delhi, SKS Law Groups & Associates"
  />

  <link
    rel="canonical"
    href="https://skslawgroupsandassociates.com/services"
  />
</Helmet>
    <section className="py-24 px-6 md:px-12" >
      <div className="max-w-7xl mx-auto">
        
        {/* SECTION HEADER */}
        <div className="mb-20">
          <div className="flex items-center gap-4 mb-6">
            <div className="h-[2px] w-16" style={{ backgroundColor: COLORS.gold }}></div>
            <span style={{ color: COLORS.gold }} className="uppercase tracking-[0.4em] text-[10px] font-bold">
              Our Expertise
            </span>
          </div>
          <h2 className="text-5xl md:text-7xl text-black font-bold leading-tight tracking-tighter">
            Legal <span className=" font-light opacity-50">Practices.</span>
          </h2>
        </div>

        {/* SERVICES GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service) => (
            <div 
              key={service.id} 
              className="group relative p-10 rounded-2xl border border-white/5 transition-all duration-500 hover:-translate-y-2 flex flex-col justify-between overflow-hidden shadow-2xl"
              style={{ backgroundColor: COLORS.bgSecondary }}
            >
              {/* Top Animated Border */}
              <div 
                className="absolute top-0 left-0 h-[4px] w-0 group-hover:w-full transition-all duration-700 rounded-t-2xl"
                style={{ backgroundColor: COLORS.gold }}
              />

              {/* Content Area */}
              <div>
                {/* Large Visual Icon */}
                <div className="text-5xl mb-8 transform transition-transform duration-500 group-hover:scale-110 group-hover:rotate-6 block">
                  {service.icon}
                </div>

                {/* Title - Bold & Large */}
                <h3 className="text-white text-3xl font-bold mb-5 tracking-tight group-hover:text-[#C6A75E] transition-colors">
                  {service.title}
                </h3>

                {/* Description - Clean & Readable */}
                <p className="text-gray-400  text-lg leading-relaxed mb-10 font-light group-hover:text-gray-200 transition-colors">
                  {service.shortDesc}
                </p>
              </div>

              {/* Action Link */}
              <a 
                href={`/services/${service.id}`}
                className="inline-flex items-center gap-3 text-sm font-bold uppercase tracking-[0.2em] transition-all"
                style={{ color: COLORS.gold }}
              >
                <span>Read More</span>
                <div className="flex items-center justify-center w-8 h-8 rounded-full border border-[#C6A75E]/30 group-hover:bg-[#C6A75E] group-hover:text-[#0B1C2D] transition-all">
                  <ChevronRight size={16} />
                </div>
              </a>

              {/* Background Number Detail (Subtle) */}
              <span className="absolute -bottom-4 -right-2 text-8xl font-black opacity-[0.02] select-none pointer-events-none text-white italic">
                {service.id}
              </span>
            </div>
          ))}
        </div>

      </div>
    </section>
    </>
  );
};

export default ServicesList;